'use strict';
import React from 'react';
import * as T from 'prop-types';
import classNames from 'classnames';
import {ReportFormat} from '../../../enums/ReportFormat';
import {I18nComponent} from '../../../react-i18n/I18nComponent';


export function BaseExportModalFormatSelector(props) {
  return (
    <ul className={classNames(props.className, 'list filter-flex')}>
      <li
        className={classNames('item item-checkbox filter-half-item', {
          'filter-selected': props.format === ReportFormat.XLSX,
        })}
      >
        <label
          htmlFor="ExportModal_xlsx"
          className="checkbox filter-check filter-square-check"
        >
          <input
            id="ExportModal_xlsx"
            type="checkbox"
            value={props.format === ReportFormat.XLSX}
            onChange={props.onChangeFormatXlsx}
          />
        </label>
        <span>
          {props.formatXlsxLabel}
        </span>
      </li>
      <li
        className={classNames('item item-checkbox filter-half-item', {
          'filter-selected': props.format === ReportFormat.CSV,
        })}
      >
        <label
          htmlFor="ExportModal_csv"
          className="checkbox filter-check filter-square-check"
        >
          <input
            id="ExportModal_csv"
            type="checkbox"
            value={props.format === ReportFormat.CSV}
            onChange={props.onChangeFormatCsv}
          />
        </label>
        <span>
          {props.formatCsvLabel}
        </span>
      </li>

    </ul>
  );
}

BaseExportModalFormatSelector.propTypes = {
  format: T.string.isRequired,

  onChangeFormatXlsx: T.func,
  onChangeFormatCsv: T.func,

  formatHeaderLabel: T.string,
  formatXlsxLabel: T.string,
  formatCsvLabel: T.string,
};

BaseExportModalFormatSelector.defaultProps = {
  className: '',
};

export const formatHeaderLabel = {code: 'timers.export.format.header.label', prop: 'formatHeaderLabel'};

export const ExportModalFormatSelector = I18nComponent(BaseExportModalFormatSelector, [
  {code: 'timers.export.format.xlsx.label', prop: 'formatXlsxLabel'},
  {code: 'timers.export.format.csv.label', prop: 'formatCsvLabel'},
]);



// WEBPACK FOOTER //
// ./src/js/core-utilities/redux-observable-list-exports/components/ExportModalHOC/ExportModalFormatSelector.js